export default __webpack_public_path__ + "static/media/Juego_paso36.ce131d3a.png";